<template>
  <div class="con-left">
    <img style="margin-top:111px;" :src="menuslogon" width="271px" height="90px" />
    <div class="left-font">埃克森美孚（中国）投资有限公司</div>
  </div>
</template>
<script>
import menuslogon from '@/assets/images/menu-logo.png'
export default {
   data(){
       return {
           menuslogon
       }
   } 
}
</script>
<style scoped >
 .con-left {
        width: 475px;
        height: 520px;
        background: linear-gradient(135deg, #0045A3 0%, #00439E 100%);
        border-radius: 0px 0px 0px 40px;
        opacity: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
      }

      .left-font {
        font-size: 12px;
     
        font-weight: 500;
        color: #FFFFFF;
        line-height: 0px;
        position: absolute;
        bottom: 67px;
      }
</style>